var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossWhiteIconWithBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71491 0 0 6.7162 0 15C0 23.2838 6.71491 30 15 30C23.2851 30 30 23.2838 30 15C30 6.7162 23.2838 0 15 0ZM15 28.2296C7.69281 28.2296 1.77039 22.3059 1.77039 15C1.77039 7.6941 7.69249 1.77039 15 1.77039C22.3075 1.77039 28.2296 7.6941 28.2296 15C28.2296 22.3059 22.3059 28.2296 15 28.2296Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1953 9.5885L9.58871 20.1951",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58594 9.5885L20.1925 20.1951",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWhiteIconWithBorder);
export default __webpack_public_path__ + "static/media/crossWhiteIconWithBorder.0be43c042c5a2d5350ba05c9b8dd608d.svg";
export { ForwardRef as ReactComponent };